module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Edit Motion")]), _vm._v(" "), _c('section', {
    staticClass: "Message"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "ui form addMotionForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.$_admin_motion_edit_checkEditMessage($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('button', {
    staticClass: "btn bg-olive margin",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": _vm.$t('add')
    },
    on: {
      "click": _vm.$_admin_motion_edit_addRow
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].descAddI18n) + "\n                            ")]), _vm._v(" "), _vm._l((_vm.motionFile.i18n), function(o, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].desc) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_vm._m(0, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.description),
        expression: "o.description"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "description",
        "type": "text"
      },
      domProps: {
        "value": (o.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "description", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3",
      class: {
        'form-group has-error': _vm.$v.motionFile.i18n.$each[index].$invalid
      }
    }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].langCode) + ":")]), _vm._v(" "), (!_vm.$v.motionFile.i18n.$each[index].langCode.required) ? _c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].required))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_vm._m(1, true), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.langCode),
        expression: "o.langCode"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "langCode"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(o, "langCode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "zh-CN"
      }
    }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].typeZHCN))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "zh-TW"
      }
    }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].typeZHTW))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "en"
      }
    }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].typeEN))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1 trash"
    }, [_c('a', {
      staticClass: "btn btn-danger",
      attrs: {
        "href": "#",
        "data-toggle": "tooltip",
        "data-placement": "top",
        "title": _vm.$t('trash')
      },
      on: {
        "click": function($event) {
          _vm.$_admin_motion_edit_removeRow(o)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o fa-lg"
    })])])])
  }), _vm._v(" "), _c('br')], 2)]), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6",
    class: {
      'form-group has-error': _vm.$v.motionFile.name.$invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].motionName) + ":")]), _vm._v(" "), (!_vm.$v.motionFile.name.required) ? _c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].required))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motionFile.name),
      expression: "motionFile.name"
    }],
    ref: "addMotionTitle",
    staticClass: "form-control",
    attrs: {
      "placeholder": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.motionFile.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.motionFile, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    class: {
      'form-group has-error': _vm.$v.motionFile.type.$invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].type) + ":")]), _vm._v(" "), (!_vm.$v.motionFile.type.required) ? _c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].required))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motionFile.type),
      expression: "motionFile.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.motionFile, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "motion"
    }
  }, [_vm._v("motion")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "motion_bin"
    }
  }, [_vm._v("motion_bin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "maya"
    }
  }, [_vm._v("maya")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "media"
    }
  }, [_vm._v("media")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6",
    class: {
      'form-group has-error': _vm.$v.motionFile.category.$invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].category) + ":")]), _vm._v(" "), (!_vm.$v.motionFile.category.required) ? _c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].required))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motionFile.category),
      expression: "motionFile.category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.motionFile, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.categories), function(category, index) {
    return _c('option', {
      domProps: {
        "value": category.motionCategoryId
      }
    }, [_vm._v("\n                                                " + _vm._s(category.i18n.description) + "\n                                            ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.motionFile.type) ? _c('div', {
    staticClass: "col-md-6",
    class: {
      'form-group has-error': _vm.$v.motionFile.fileName.$invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].downloadUrl) + ":")]), _vm._v(" "), (!_vm.$v.motionFile.fileName.required) ? _c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].required))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": _vm.fileAccept
    },
    on: {
      "change": function($event) {
        _vm.$_admin_motion_upload($event, 'fileName')
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motionFile.fileName),
      expression: "motionFile.fileName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "file name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.motionFile.fileName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.motionFile, "fileName", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6",
    class: {
      'form-group has-error': _vm.$v.motionFile.time.$invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].time) + ":")]), _vm._v(" "), (!_vm.$v.motionFile.time.required) ? _c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].required))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motionFile.time),
      expression: "motionFile.time"
    }],
    ref: "addMotionTitle",
    staticClass: "form-control",
    attrs: {
      "placeholder": "time",
      "type": "text"
    },
    domProps: {
      "value": (_vm.motionFile.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.motionFile, "time", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    class: {
      'form-group has-error': _vm.$v.motionFile.size.$invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].size) + ":")]), _vm._v(" "), (!_vm.$v.motionFile.size.required) ? _c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].required))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motionFile.size),
      expression: "motionFile.size"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "size",
      "type": "text"
    },
    domProps: {
      "value": (_vm.motionFile.size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.motionFile, "size", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    class: {
      overlay: true, hidden: !_vm.loading
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].keyword) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('label', [_vm._v(" ")]), _c('br'), _vm._v(" "), _c('button', {
    class: 'btn',
    attrs: {
      "id": "searchSubmitButton",
      "type": "button"
    },
    on: {
      "click": _vm.$_admin_motion_tag_search
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-search"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'form-group has-error': _vm.$v.motionFile.tagIds.$invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].tag) + ":")]), _vm._v(" "), (!_vm.$v.motionFile.tagIds.required) ? _c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].required))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempTagList),
      expression: "tempTagList"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "size": "4"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tempTagList = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.tags), function(tag, index) {
    return _c('option', {
      domProps: {
        "value": tag
      }
    }, [_vm._v("\n                                                " + _vm._s(tag.i18n.description) + "\n                                            ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('label', [_vm._v(" ")]), _c('br'), _vm._v(" "), _c('button', {
    class: 'btn',
    attrs: {
      "id": "searchSubmitButton",
      "type": "button"
    },
    on: {
      "click": _vm.$_admin_motion_tag_add
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-menu-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'form-group has-error': _vm.$v.motionFile.tagIds.$invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].tag) + ":")]), _vm._v(" "), (!_vm.$v.motionFile.tagIds.required) ? _c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].required))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motionFile.tagIds),
      expression: "motionFile.tagIds"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "size": "4"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.motionFile, "tagIds", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.tags), function(tag, index) {
    return _c('option', {
      domProps: {
        "value": tag.motionTagId
      }
    }, [_vm._v("\n                                                " + _vm._s(tag.i18n.description) + "\n                                            ")])
  }))])])])]), _vm._v(" "), _c('div', {
    class: {
      overlay: true, hidden: !_vm.loading
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    class: 'btn btn-warning btn-lg ' + _vm.loading,
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": _vm.$t('clear')
    },
    on: {
      "click": function($event) {
        _vm.$_admin_motion_edit_clearInput()
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].clear) + "\n                                ")]), _vm._v(" "), _c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit",
      "disabled": _vm.$v.$invalid || _vm.isUploading,
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": _vm.$t('submit')
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.isUploading ? _vm.$i18n.messages[_vm.$i18n.locale].uploading : _vm.$i18n.messages[_vm.$i18n.locale].submit) + "\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    class: {
      overlay: true, hidden: !_vm.loading
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-success alert-dismissible",
    class: {
      hidden: !_vm.insertSuccess
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.$_admin_motion_edit_closeAndRedirect()
      }
    }
  }, [_vm._v("\n                            ×\n                        ")]), _vm._v(" "), _c('h4', [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].success) + "!")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Inputs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-book",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tags",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tags",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7423e801"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/EditMotionFileForAdmin.vue
// module id = 1498
// module chunks = 1